import { Component, OnInit, ViewChild, DoCheck } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ResultStatus } from "@app/core/models/result-status";
import { AuthService } from "@app/core/services/auth.service";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { CommunityService } from "@app/core/services/community.service";
import { HelperService } from "@app/core/services/helper.service";
import { AppConfig } from "@app/core/Utilities/app-config.service";
import { ExcelFileExtension } from "@app/modules/agent/pages/agent-activity-detail/agent-activity-detail.component";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";

@Component({
  selector: "app-post-referral",
  templateUrl: "./post-referral.component.html",
  styleUrls: ["./post-referral.component.scss"],
})
export class PostReferralComponent implements OnInit, DoCheck {
  isDataLoaded = false;
  locationPlaceholderText = "select";
  searchkwdLocation = "";
  searchSubmitted = false;
  postAReferralForm: FormGroup;
  submitted = false;
  submitEnable = true;
  groupFilterList = [];
  userInfo: any;

  public uploadImagesFormData: FormData;
  public onUploadClicked: Subject<any> = new Subject();
  @ViewChild("fileUploder") public fileUploder: any;
  public fileUploaderSettings = {
    name: "fileUploader1",
    url: "",
    disabled: false,
    styleClass: "customUploadIcon",
    allowMultiple: true,
    mode: "advanced",
    accept:
      "image/*, application/msword, application/pdf, video/*, .doc,.docx",
    maxFileSize: 5000000,
    auto: false,
    chooseLabel: "Attach",
    uploadLabel: "Upload",
    cancelLabel: "Cancel",
    showUploadButton: false,
    showCancelButton: false,
    customUpload: true,
    fileLimit: 5,
    files: "",
  };
  uploadedFiles = [];
  fileUploaderData: any;
  fileExtension: any = ExcelFileExtension;
  fileUploaders: any[];

  postDetail: any;
  postId: any;

  searchkeywordForLocation = '';

  constructor(
    private communityService: CommunityService,
    private formBuilder: FormBuilder,
    private _toaster: ToastrService,
    private _appConfig: AppConfig,
    public modalRef: BsModalRef,
    private toaterService: ToastrService,
    private sanit: DomSanitizer,
    private authService: AuthenticationService,
    private helperService: HelperService,
    private authService1: AuthService,
    private modalService: BsModalService,
    public appConfig: AppConfig
  ) {
    this.postId = this.modalService.config.initialState["postID"];
  }

  ngOnInit() {
    this.getGroupList();
    this.setUpdateFormData();
    this.fileUploaders = [
      {
        fileUploaderSettings: this.fileUploaderSettings,
        uploadedFiles: this.uploadedFiles,
      },
    ];
    this.fileUploaderData = _.cloneDeep(this.fileUploaders);
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.postId)) {
      this.getPostById();
    } else {
      this.isDataLoaded = true;
    }
  }

  ngDoCheck() {
    if (
      this.fileUploder &&
      this.fileUploder.fileUpload &&
      this.fileUploder.fileUpload.files
    ) {
      if (!this.fileUploder.fileUpload.files.length) {
        this.fileUploaderData[0].fileUploaderSettings.showUploadButton = false;
      }
    }
  }

  getPostById() {
    this.communityService
      .getCommunityPostById(this.postId)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.postDetail = result.Data;
          this.postAReferralForm.setValue({
            group: this.postDetail.GroupId,
            title: this.postDetail.Title,
            description: this.postDetail.Description,
            tag: this.postDetail.Tag,
            location: this.postDetail.Location,
          });
          this.searchkeywordForLocation = this.postDetail.Location;
          this.isDataLoaded = true;
        } else {
          this.toaterService.error("something went wrong");
        }
      });
  }

  getGroupList() {
    this.communityService.getAssociatedGroups().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.groupFilterList = result.Data;
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  setUpdateFormData() {
    this.postAReferralForm = this.formBuilder.group({
      group: new FormControl("", [Validators.required]),
      title: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
      tag: new FormControl("#referral"),
      location: new FormControl("", [Validators.required]),
    });
  }

  searchKeyWorkForLocation(keyWork: any) {
    this.searchkwdLocation = keyWork;
    if (this.searchkwdLocation) {
      if (this.searchkwdLocation.trim().length > 0) {
        this.searchSubmitted = false;
      }
    }
  }

  selectedItem(item: any) {
    this.postAReferralForm.controls["location"].setValue(item.value);
  }

  postAReferral() {
    this.submitted = true;
    this.submitEnable = false;
    if (this.helperService.isUndefinedOrNullOrEmpty(this.postId)) {
      if (this.postAReferralForm.invalid) {
        this.submitEnable = true;
        return false;
      } else {
        const formData: FormData = new FormData();
        let postData = this.postAReferralForm.value;
        postData["PostTypeId"] = 3;
        postData["IsDeleted"] = false;
        postData["GroupId"] = +this.postAReferralForm.controls["group"].value;
        postData["IsHidden"] = false;

        postData = JSON.stringify(postData);
        // postData = postData.replace(/"/g, "'");
        formData.append("json", postData);

        for (const file of this.fileUploder.fileUpload.files) {
          formData.append("files", file, file.name);
        }
        this.communityService.postReferral(formData).subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.submitEnable = false;
            this.modalRef.hide();
          } else {
            this.submitEnable = true;
            this.toaterService.error("something went wrong");
          }
        });
      }
    } else {
      if (this.postAReferralForm.invalid) {
        this.submitEnable = true;
        return false;
      } else {
        const postData = this.postAReferralForm.value;
        postData["Id"] = this.postId;
        postData["GroupId"] = +this.postAReferralForm.controls["group"].value;
        this.communityService
          .updateCommunityPost(postData)
          .subscribe((result) => {
            if (result.Status === ResultStatus.Success) {
              this.submitEnable = false;
              this.modalRef.hide();
            } else {
              this.submitEnable = true;
              this.toaterService.error("something went wrong");
            }
          });
      }
    }
  }

  // Common File Uploader Methods
  filesUpload($event) {
    if (!$event) {
      return;
    }
    if (!$event.length) {
      return;
    }

    this.uploadImagesFormData = new FormData();
    let i = 0;
    // var binary = new Binary[5];
    for (const file of $event) {
      this.uploadImagesFormData.append("file", file, file.name);
      i++;
    }
  }

  onFilesSelect($event) {
    if (this.fileUploder && this.fileUploder.fileUpload.files.length > 0) {
      if (
        !!this.fileUploder &&
        this.fileUploder.fileUpload.files.length >
          this.fileUploaders[0].fileUploaderSettings.fileLimit
      ) {
        this._toaster.error(
          "You can upload maximum " +
            this.fileUploaders[0].fileUploaderSettings.fileLimit +
            " file",
          this._appConfig.toasterError
        );
        this.fileUploder.fileUpload.remove();
        this.fileUploder.fileUpload.files = [];
        return;
      }
    }

    // if (this.fileUploder.fileUpload.files.length) {
    //   this.fileUploaderData[0].fileUploaderSettings.showUploadButton = true;
    // }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return "0 GB";
    }
    if (isNaN(parseInt(bytes))) {
      return bytes;
    }
    if (typeof bytes === "string") {
      bytes = parseInt(bytes);
    }
    if (bytes === 0) {
      return "0";
    }
    const k = 1000;
    const dm = decimals + 1 || 3;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  }

  removeFile(fileName: any) {
    let index = 0;
    this.fileUploder.fileUpload.files.forEach((element) => {
      if (element.name === fileName) {
        this.fileUploder.fileUpload.files.splice(index, 1);
      }

      index++;
    });

    if (!this.fileUploder.fileUpload.files.length) {
      this.fileUploaderData[0].fileUploaderSettings.showUploadButton = false;
    }
  }

  getImgsSanitized(imageURL: any) {
    return this.sanit.bypassSecurityTrustStyle(
      "url(" + imageURL + "), url(/assets/images/user-icon.png)"
    );
  }
}
